var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.item.isshow)?_c('a-form-item',[_c('a-checkbox',{on:{"change":_vm.onChange}},[_vm._v("\n    "+_vm._s(_vm.item.showname || _vm.item.name)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }